import type { CrunchData } from '@dc-shared-web/hooks/api/document/types'
import { useAxiosContext } from '@dc-shared-web/providers'
import { useQuery } from 'react-query'
import { fetchDocumentById } from '@dc-shared-web/hooks/api/document/fetchDocumentByIdDcrunch'

export const useGetDocumentById = (
  documentId: string,
  enabled: boolean = true
) => {
  const apiClient = useAxiosContext()

  return useQuery<CrunchData, Error>({
    queryKey: ['Document', documentId],
    queryFn: () => fetchDocumentById(apiClient, documentId),
    enabled,
  })
}
